export const displayCityInformationsDetailsPanelSelector = ({displayCityInformationsDetailsPanel}) => displayCityInformationsDetailsPanel 